export const patchSuccessToast = {
  title: '変更されました $t(tracker:displayKind, {"context": "{{context}}" })',
};
